import { z } from 'zod';

export type DeliveryPriceUpdateForm = {
    brand_id?: number,
    model_id?: number,
    city_from_id?: number,
    city_to_id?: number,
    price?: number,
    estimated_days?: number,
};

export type DeliveryPriceUpdateFormErrors = {
    brand_id?: string[],
    model_id?: string[],
    city_from_id?: string[],
    city_to_id?: string[],
    price?: string[],
    estimated_days?: string[],
};

export function mapDeliveryPriceUpdateFormToRequestForm(updateForm: DeliveryPriceUpdateForm): DeliveryPriceUpdateForm {
    const requestForm: DeliveryPriceUpdateForm = {};

    if (updateForm.brand_id !== undefined) {
        requestForm.brand_id = updateForm.brand_id;
    }

    if (updateForm.model_id !== undefined) {
        requestForm.model_id = updateForm.model_id;
    }

    if (updateForm.city_from_id !== undefined) {
        requestForm.city_from_id = updateForm.city_from_id;
    }

    if (updateForm.city_to_id !== undefined) {
        requestForm.city_to_id = updateForm.city_to_id;
    }

    if (updateForm.price !== undefined) {
        requestForm.price = updateForm.price;
    }

    if (updateForm.estimated_days !== undefined) {
        requestForm.estimated_days = updateForm.estimated_days;
    }

    return requestForm;
}

export function makeEmptyDeliveryPriceUpdateForm(): DeliveryPriceUpdateForm {
    return {
        brand_id: undefined,
        model_id: undefined,
        city_from_id: undefined,
        city_to_id: undefined,
        price: undefined,
        estimated_days: 0,
    };
}

export const DeliveryPriceUpdateFormErrorsSchema = z.object({
    brand_id: z.array(z.string()).optional(),
    model_id: z.array(z.string()).optional(),
    city_from_id: z.array(z.string()).optional(),
    city_to_id: z.array(z.string()).optional(),
    price: z.array(z.string()).optional(),
    estimated_days: z.array(z.string()).optional(),
});
